import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Paragraph, Anchor, Box } from '@zillow/constellation';
import { useLastValidClosingCostCalculator, FieldConfig, fetchRate, fetchPropertyTaxRate, roundToNearestInteger } from './ClosingCostCalculator.utils.js';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import DownPaymentField from './DownPaymentField.js';
import TextField from '../Fields/TextField.js';
import SelectField from '../Fields/SelectField.js';
import LegalPopover from '../CalculatorForm/LegalPopover.js';
import InterestRateField from './InterestRateField.js';
import { setServerUrl, createMax } from '../../utils/mortgagehelpers/mortgage-helpers.js';

var ClosingCostFields = function ClosingCostFields() {
  var lastValidClosingCostCalculator = useLastValidClosingCostCalculator();
  var _lastValidClosingCost = lastValidClosingCostCalculator.fields,
    homePrice = _lastValidClosingCost.homePrice,
    downPayment = _lastValidClosingCost.downPayment;
  var form = useFormContext();
  var fieldInterestRate = form.register(FieldConfig.interestRate.name, FieldConfig.interestRate.config);
  var fieldPropertyTaxes = form.register(FieldConfig.propertyTaxes.name, FieldConfig.propertyTaxes.config);
  var fieldPropertyTaxRate = form.register(FieldConfig.propertyTaxRate.name, FieldConfig.propertyTaxRate.config);
  useEffect(function () {
    // Set the server URL and create the max object
    setServerUrl();
    createMax();
    if (fieldInterestRate) {
      var getLatestRate = function getLatestRate() {
        return new Promise(function ($return, $error) {
          var rate;
          return Promise.resolve(fetchRate(homePrice, downPayment)).then(function ($await_1) {
            try {
              rate = $await_1;
              form.setValue(fieldInterestRate.name, rate);
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      };
      getLatestRate();
    }
    if (fieldPropertyTaxes) {
      var getPropertyTaxes = function getPropertyTaxes() {
        return new Promise(function ($return, $error) {
          var taxRate, taxAmount;
          return Promise.resolve(fetchPropertyTaxRate()).then(function ($await_2) {
            try {
              taxRate = $await_2;
              taxAmount = taxRate == 0 ? 315 : taxRate / 100 * homePrice / 4;
              taxRate != 0 && form.setValue(fieldPropertyTaxRate.name, taxRate);
              form.setValue(fieldPropertyTaxes.name, roundToNearestInteger(taxAmount));
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      };
      getPropertyTaxes();
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextField, {
    label: "Home price",
    name: FieldConfig.homePrice.name,
    config: FieldConfig.homePrice.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true
  }), /*#__PURE__*/React.createElement(DownPaymentField, null), /*#__PURE__*/React.createElement(InterestRateField, {
    homePrice: homePrice,
    downPayment: downPayment
  }), /*#__PURE__*/React.createElement(SelectField, {
    options: FieldConfig.purchasingAnyDiscountPoints.options,
    label: "Are you purchasing discount points?",
    name: FieldConfig.purchasingAnyDiscountPoints.name,
    config: FieldConfig.purchasingAnyDiscountPoints.config,
    tooltip: {
      title: 'Are you purchasing discount points?',
      body: /*#__PURE__*/React.createElement(Paragraph, null, "You can pay", ' ', /*#__PURE__*/React.createElement(Anchor, {
        href: "https://www.zillow.com/learn/mortgage-points/",
        target: "_blank"
      }, "discount points"), ' ', "to reduce the loan's interest rate. Each point represents 1% of the loan amount and typically lowers the interest rate by 0.25%. For example, on a $300,000 loan at 6.25%, one discount point would cost you $3,000 and lower your interest rate to a flat 6%.")
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: '0px'
    }
  }, /*#__PURE__*/React.createElement(LegalPopover, {
    style: {
      marginTop: '0px'
    },
    triggerText: "Calculator disclaimer",
    text: "The closing cost calculator is intended to be used for educational purposes only. Actual costs may vary based on specific lender fees, local assessments, and other factors such as loan type and geography. This calculator does not include all potential closing costs, such as mortgage insurance premiums (if applicable), transfer taxes, or other fees associated with specific loan programs or property locations. It is recommended to consult with a licensed  lender in your area for a more precise estimate of your closing costs. Zillow Group Marketplace, Inc. does not make loans and this is not a commitment to lend."
  })));
};
var ClosingCostFields$1 = ClosingCostFields;

export { ClosingCostFields$1 as default };
